import React, { useRef, useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { useGoalsCascadedViewData } from 'screens/Team/Rabbit/Goals/AgGridTreeView/hooks/dataHooks';
import { useTimeBoundTimePeriods } from 'screens/home/summary/components/Cards/Goals/hooks';

import GoalSectionAgGrid from './GoalSelectionAgGrid';
import Header from './Header';

const GROUP_BY = {
  uuid: null,
  keyName: 'objective',
  displayName: 'Objective',
  enabled: true,
};

const SPLIT_BY = {
  uuid: null,
  keyName: 'none',
  displayName: 'None',
  enabled: true,
};

interface Props {
  selectedId: string;
  onSelect?: (goal: Record<string, any>) => void;
  applicableEmployees: string[];
}

const GoalSelection = ({ onSelect, selectedId, applicableEmployees }: Props) => {
  const { data: timelineData } = useTimeBoundTimePeriods();

  const [localSelectedTimePeriod, setLocalSelectedTimePeriod] = useState(timelineData?.current);

  const gridRef = useRef();

  const { data } = useGoalsCascadedViewData({
    attributeFilter: {
      filterConditions: [
        {
          type: 'NAME',
          operatorType: 'IN',
          data: applicableEmployees ?? [],
        },
        {
          type: 'TYPE',
          operatorType: 'IN',
          data: ['GOAL'],
        },
      ],
    },
    cohort: null,
    groupByKeys: GROUP_BY,
    splitByKeys: SPLIT_BY,
    orderBy: null,
    timeBounds: localSelectedTimePeriod ? [localSelectedTimePeriod] : [null],
    isHierarchyView: false,
    pageType: 'PROFILE_PAGE',
    enabled: applicableEmployees?.length > 0,
  });

  return (
    <Flex backgroundColor="#FFFFFF" h="100%" flexDirection="column">
      <Flex flexDirection="column" flex={1}>
        <Header
          gridRef={gridRef}
          localSelectedTimePeriod={localSelectedTimePeriod}
          setLocalSelectedTimePeriod={setLocalSelectedTimePeriod}
        />

        <GoalSectionAgGrid gridRef={gridRef} gridData={data} onSelect={onSelect} selectedId={selectedId} />
      </Flex>
    </Flex>
  );
};

export default GoalSelection;
